import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CustomAttributesFilter } from 'tabs/accessControl/accessControlApi/types';

export type PrimaryLabelFilter = {
  siteIds: [string] | [];
  labelIds: string[];
};
export type Authorisations = 'authorised' | 'unauthorised' | 'unknown';

type AccessControlFilter = {
  selectedLabels: PrimaryLabelFilter;
  selectedAuthorisations: Authorisations[];
  customAttributes: CustomAttributesFilter[];
};

const initialState: AccessControlFilter = {
  selectedLabels: {
    siteIds: [],
    labelIds: [],
  },
  customAttributes: [],
  selectedAuthorisations: [],
};

const accessControlDashboardFilterSlice = createSlice({
  name: 'accessControlDashboardFilters',
  initialState,
  reducers: {
    updateLabels(state, action: PayloadAction<PrimaryLabelFilter>) {
      state.selectedLabels = action.payload;
    },
    updateAuthorisations(state, action: PayloadAction<Authorisations[]>) {
      state.selectedAuthorisations = action.payload;
    },
    updateCustomAttributes(
      state,
      {
        payload: { attribute, value_contains },
      }: PayloadAction<CustomAttributesFilter>,
    ) {
      const customAttrToUpdate = state.customAttributes.findIndex(
        (customAttr) => customAttr.attribute === attribute,
      );

      if (value_contains === '') {
        state.customAttributes = state.customAttributes.filter(
          (customAttr) => customAttr.attribute !== attribute,
        );
        return;
      }

      if (customAttrToUpdate !== -1) {
        state.customAttributes[customAttrToUpdate] = {
          attribute,
          value_contains,
        };
      } else {
        state.customAttributes.push({
          attribute,
          value_contains,
        });
      }
    },
    resetAttributesFilter(state) {
      state.customAttributes = [];
    },
  },
});

export const {
  updateLabels,
  updateAuthorisations,
  updateCustomAttributes,
  resetAttributesFilter,
} = accessControlDashboardFilterSlice.actions;

export default accessControlDashboardFilterSlice.reducer;
